import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const budgets = (state = initialState.budgets, action) => {
  switch (action.type) {
    case types.GET_BUDGET_SUCCESS:
      return state.find((b) => b.id === action.id);
    case types.LOAD_BUDGET_SUCCESS:
      return action.budget;
    case types.ADD_BUDGET_SUCCESS:
      return [...state, action.budget];
    default:
      return state;
  }
};
